import { ARROW_SVG_PATHS, DICT_DEFAULT_RESOURCE_TEXT, MODAL_STEPS, NAVIGATION_EVENTS } from "../utils/constants";
import { disableElement, hideElement } from "../utils/dom";
import ButtonComponent from "./button.component";

export default class NavigationComponent extends HTMLElement {

    #resourcesService;
    #backButton;
    #nextButton;


    constructor() {
        super();
    }

    connectedCallback() {
        this.#backButton = this.#createNavigationButton("v24SchedulerBackButton", NAVIGATION_EVENTS.goBack);
        this.#nextButton = this.#createNavigationButton("v24SchedulerNextButton", NAVIGATION_EVENTS.goNext);
    }

    #createNavigationButton(id, eventName) {
        const button = new ButtonComponent();
        button.id = id;
        button.tabIndex = 0;
        button.setAttribute("aria-label", eventName);
        this.appendChild(button);

        const dispatchNavigationEvent = () => {
            // Don't dispatch event if button is disabled
            if (button.disabled || button.getAttribute("aria-disabled") === "true") {
                return;
            }
            this.dispatchEvent(new CustomEvent(eventName));
        };

        button.addEventListener("click", dispatchNavigationEvent);
        button.addEventListener("keydown", (event) => {
            if (event.key === "Enter" || event.key === " ") {
                event.preventDefault();
                dispatchNavigationEvent();
            }
        });

        return button;
    }

    init(resourcesService) {
        this.#resourcesService = resourcesService;
        this.renderLabelsForStep(0);
        if (this.#resourcesService.getResource("SELFSCHEDULER_SHOW_ARROWS_ON_NAVIGATION", "0") === "1") {
            this.#backButton.startIconPath = ARROW_SVG_PATHS.Back;
            this.#nextButton.endIconPath = ARROW_SVG_PATHS.Next;
        }

        return this;
    }

    renderLabelsForStep(currentStep) {

        //TODO: this is shit and should be improved
        if (currentStep === MODAL_STEPS.appointmentRegistrationStep) {
            this.#nextButton.labelText = this.#resourcesService.getResource("SELFSCHEDULER_SUBMIT", DICT_DEFAULT_RESOURCE_TEXT.SELFSCHEDULER_SUBMIT);
        }
        else {
            this.#nextButton.labelText = this.#resourcesService.getResource("SELFSCHEDULER_NEXT", DICT_DEFAULT_RESOURCE_TEXT.SELFSCHEDULER_NEXT);
        }

        this.#backButton.labelText = this.#resourcesService.getResource("SELFSCHEDULER_BACK", DICT_DEFAULT_RESOURCE_TEXT.SELFSCHEDULER_BACK);
        this.#nextButton.setAttribute("aria-label", this.#nextButton.labelText);
        this.#backButton.setAttribute("aria-label", this.#backButton.labelText);
        return this;
    }

    showNext(val) {
        hideElement(this.#nextButton, !val);
        return this;
    }

    showBack(val) {
        hideElement(this.#backButton, !val);
        return this;
    }

    enableNext(val) {
        disableElement(this.#nextButton, !val);
        return this;
    }

    enableBack(val) {
        disableElement(this.#backButton, !val);
        return this;
    }

    focusNext() {
        this.#nextButton.focus();
        return this;
    }

    hide() {
        hideElement(this, true);
        return this;
    }

}